import { NgModule }                     from '@angular/core';
import {
	FormsModule,
	ReactiveFormsModule
}                                       from '@angular/forms';
import { FormDatepickerModule }         from '@shared/form-elements/form-datepicker/form-datepicker.module';
import { FormDateRangePickerModule }    from '@shared/form-elements/form-daterangepicker/form-date-range-picker.module';
import { FormElementsGroupBlockModule } from '@shared/form-elements/form-elements-group-block/form-elements-group-block.module';
import { FormInputModule }              from '@shared/form-elements/form-input/form-input.module';
import { FormSelectModule }             from '@shared/form-elements/form-select/form-select.module';
import { FormSwitchModule }             from '@shared/form-elements/form-switch/form-switch.module';
import { FormTextareaModule }           from '@shared/form-elements/form-textarea/form-textarea.module';
import { AddressFormModule }            from '@shared/forms/address-form/address-form.module';
import { NaturalPersonFormModule }      from '@shared/forms/natural-person-form/natural-person-form.module';

@NgModule( {
	declarations: [],
	imports: [],
	exports: [
		FormsModule,
		ReactiveFormsModule,

		AddressFormModule,
		FormElementsGroupBlockModule,
		FormDatepickerModule,
		FormDateRangePickerModule,
		FormInputModule,
		FormSelectModule,
		FormSwitchModule,
		FormTextareaModule,
		NaturalPersonFormModule
	]
} )
export class SharedFormModule {}
